import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import ButtonLoading from "../../../components/Loder/buttonLoading";

const EditAccount = () => {
  const navigate = useNavigate();
  const { state: accountId } = useLocation();

  const { register, handleSubmit, setValue } = useForm();

  const [loading, setLoading] = useState(false);
  const [accountClasses, setAccountClasses] = useState([]);
  const [subClasses, setSubClasses] = useState([]);

  useEffect(() => {
    axios
      .get(API + "accounting/account-classes/", { headers: authHeader() })
      .then(res => setAccountClasses(res.data || []));
  }, []);

  useEffect(() => {
    if (!accountId) return;

    axios
      .get(API + `accounting/account-detail/${accountId}/`, {
        headers: authHeader(),
      })
      .then(res => {
        const data = res.data;

        setValue("account_code", data.account_code);
        setValue("account_number", data.account_number);
        setValue("account_class", data.account_class?.id || "");
        setValue("account_subclass", data.account_subclass?.id || "");
        setValue("manual", data.manual);
        setValue("active", data.active);

        if (data.account_class?.id) {
          loadSubClasses(data.account_class.id);
        }
      });
  }, [accountId]);

  const loadSubClasses = (classId) => {
    axios
      .get(`${API}accounting/account-subclasses/?class_id=${classId}`, {
        headers: authHeader(),
      })
      .then(res => setSubClasses(res.data.data || res.data || []));
  };

  const onSubmit = (data) => {
    setLoading(true);

    axios.post(
      API + `accounting/account-edit/${accountId}/`,
      data,
      { headers: authHeader() }
    )
    .then(() => {
      toast.success("Account Updated Successfully");
      setTimeout(() => navigate("/accounts"), 1000);
    })
    .catch(() => toast.error("Update Failed"))
    .finally(() => setLoading(false));
  };

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <h5>Edit Account</h5>

        <form onSubmit={handleSubmit(onSubmit)}>

          <input className="form-control mb-2" {...register("account_code")} />
          <input className="form-control mb-2" {...register("account_number")} />

          <select
            className="form-control mb-2"
            {...register("account_class")}
            onChange={(e) => loadSubClasses(e.target.value)}
          >
            <option value="">Select Class</option>
            {accountClasses.map(c => (
              <option key={c.id} value={c.id}>{c.class_name}</option>
            ))}
          </select>

          <select className="form-control mb-2" {...register("account_subclass")}>
            <option value="">Select Subclass</option>
            {subClasses.map(s => (
              <option key={s.id} value={s.id}>{s.subclass_name}</option>
            ))}
          </select>

          <select className="form-control mb-2" {...register("manual")}>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </select>

          <select className="form-control mb-2" {...register("active")}>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </select>

          <button className="btn btn-primary" disabled={loading}>
            {loading ? <ButtonLoading /> : "Update"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditAccount;